import { ServiceLocation } from 'src/api/@generated/backend';

class ServiceLocationsUtils {
  public static getSelectedServiceLocation = (
    serviceLocations: ServiceLocation[],
    siteId: number,
  ): ServiceLocation | undefined => serviceLocations.find((serviceLocation) => serviceLocation.siteId === siteId);
}

export { ServiceLocationsUtils };
